import type { ConfigurationContextValue } from "./ConfigurationContext";
// Import the logos as module assets so Vite resolves their URL relative to the
// JS chunk (import.meta.url), not the current route. A plain "./logos/..." path
// breaks on nested routes like /oauth/consent and under a deployment sub-path.
import darkModeLogo from "./logos/logo_atomic_crm_dark.svg";
import lightModeLogo from "./logos/logo_atomic_crm_light.svg";

export const defaultDarkModeLogo = darkModeLogo;
export const defaultLightModeLogo = lightModeLogo;

export const defaultCurrency = "BRL";

export const defaultTitle = "CRM Cultivar";

export const defaultCompanySectors = [
  { value: "agroquimica", label: "Agroquímica" },
  { value: "maquinas", label: "Máquinas" },
  { value: "implementos", label: "Implementos" },
  { value: "fertilizantes", label: "Fertilizantes" },
  { value: "sementes", label: "Sementes" },
  { value: "bancos", label: "Bancos" },
  { value: "carros", label: "Carros" },
  { value: "outros", label: "Outros" },
  { value: "biologicos", label: "Biológicos" },
];

export const defaultRevistas = [
  { value: "maquinas", label: "Máquinas" },
  { value: "grandes-culturas", label: "Grandes Culturas" },
  { value: "hortalicas-frutas", label: "Hortaliças e Frutas" },
  { value: "site", label: "Site" },
];

export const defaultDealStages = [
  { value: "planejada", label: "Planejada" },
  { value: "primeiro-contato", label: "Primeiro contato" },
  { value: "proposta-enviada", label: "Proposta enviada" },
  { value: "em-negociacao", label: "Em negociação" },
  { value: "fechado", label: "Fechado" },
  { value: "perdido", label: "Perdido" },
];

export const defaultDealPipelineStatuses = [
  "planejada",
  "primeiro-contato",
  "proposta-enviada",
  "em-negociacao",
  "fechado",
];

export const defaultDealCategories = [
  { value: "maquinas", label: "Máquinas" },
  { value: "hf", label: "Hortaliças e Frutas" },
  { value: "site", label: "Site" },
  { value: "grandes-culturas", label: "Grandes Culturas" },
];

export const defaultNoteStatuses = [
  { value: "cold", label: "Frio", color: "#7dbde8" },
  { value: "warm", label: "Morno", color: "#e8cb7d" },
  { value: "hot", label: "Quente", color: "#e88b7d" },
  { value: "in-contract", label: "Em contrato", color: "#a4e87d" },
];

export const defaultTaskTypes = [
  { value: "none", label: "Nenhum" },
  { value: "email", label: "E-mail" },
  { value: "demo", label: "Demonstração" },
  { value: "lunch", label: "Almoço" },
  { value: "meeting", label: "Reunião" },
  { value: "follow-up", label: "Acompanhamento" },
  { value: "thank-you", label: "Agradecimento" },
  { value: "ship", label: "Envio" },
  { value: "call", label: "Ligação" },
];

export const defaultConfiguration: ConfigurationContextValue = {
  companySectors: defaultCompanySectors,
  revistas: defaultRevistas,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
};
